var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLighting = function SvgLighting(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a7fd0138-495f-4373-b9f4-2d2b0e8fe421",
    "data-name": "Layer 9",
    viewBox: "0 0 82.1 105.6",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b14c2677-b69d-452d-8223-2bf37b8566cc",
    d: "M89.17,106.43h-6.6a8,8,0,0,1-7.94-7.74,12.34,12.34,0,0,1-7.48-11.24v-9a41,41,0,1,1,37.45,0v9a12.34,12.34,0,0,1-7.48,11.24A8,8,0,0,1,89.17,106.43ZM85.87,6.05a35.84,35.84,0,0,0-15,68.37,2.61,2.61,0,0,1,1.52,2.37V87.45a7.07,7.07,0,0,0,5.45,6.82,2.6,2.6,0,0,1,2,2.54v1.67a2.73,2.73,0,0,0,2.73,2.73h6.6a2.73,2.73,0,0,0,2.73-2.73V96.81a2.6,2.6,0,0,1,2-2.54,7.07,7.07,0,0,0,5.45-6.82V76.79a2.61,2.61,0,0,1,1.51-2.37,35.83,35.83,0,0,0-15-68.37Z",
    transform: "translate(-44.82 -0.83)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b14c2677-b69d-452d-8223-2bf37b8566cc",
    d: "M102,87.92H69.76a2.61,2.61,0,0,1,0-5.22H102a2.61,2.61,0,0,1,0,5.22Z",
    transform: "translate(-44.82 -0.83)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLighting, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lighting.f28f3d1e.svg";
export { ForwardRef as ReactComponent };